"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.amino_acid_text_color = exports.amino_acid_colors = exports.amino_acid_color = exports.nucleotide_difference = exports.nucleotide_text_color = exports.nucleotide_colors = exports.nucleotide_color = void 0;

var _amino_acid_colors;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ambiguous_color = "DarkGrey",
    ambiguous_text_color = "black";

var nucleotide_colors = {
  a: "LightPink",
  g: "LemonChiffon",
  t: "LightBlue",
  c: "MediumPurple",
  y: ambiguous_color,
  r: ambiguous_color,
  w: ambiguous_color,
  s: ambiguous_color,
  k: ambiguous_color,
  m: ambiguous_color,
  d: ambiguous_color,
  v: ambiguous_color,
  h: ambiguous_color,
  b: ambiguous_color,
  n: ambiguous_color,
  x: ambiguous_color,
  A: "LightPink",
  G: "LemonChiffon",
  T: "LightBlue",
  C: "MediumPurple",
  Y: ambiguous_color,
  R: ambiguous_color,
  W: ambiguous_color,
  S: ambiguous_color,
  K: ambiguous_color,
  M: ambiguous_color,
  D: ambiguous_color,
  V: ambiguous_color,
  H: ambiguous_color,
  B: ambiguous_color,
  N: ambiguous_color,
  X: ambiguous_color,
  "-": "lightgrey"
},
    nucleotide_text_colors = {
  a: "Red",
  g: "GoldenRod",
  t: "Blue",
  c: "DarkMagenta",
  y: ambiguous_text_color,
  r: ambiguous_text_color,
  w: ambiguous_text_color,
  s: ambiguous_text_color,
  k: ambiguous_text_color,
  m: ambiguous_text_color,
  d: ambiguous_text_color,
  v: ambiguous_text_color,
  h: ambiguous_text_color,
  b: ambiguous_text_color,
  n: ambiguous_text_color,
  x: ambiguous_text_color,
  A: "Red",
  G: "GoldenRod",
  T: "Blue",
  C: "DarkMagenta",
  Y: ambiguous_text_color,
  R: ambiguous_text_color,
  W: ambiguous_text_color,
  S: ambiguous_text_color,
  K: ambiguous_text_color,
  M: ambiguous_text_color,
  D: ambiguous_text_color,
  V: ambiguous_text_color,
  H: ambiguous_text_color,
  B: ambiguous_text_color,
  N: ambiguous_text_color,
  X: ambiguous_text_color,
  "-": "DarkGrey"
},
    amino_acid_colors = (_amino_acid_colors = {
  "-": "Snow",
  a: "lightblue",
  c: "pink",
  d: "LightSteelBlue",
  e: "purple",
  f: "AntiqueWhite",
  g: "LightSalmon",
  h: "CadetBlue",
  i: "Crimson",
  k: "DarkCyan",
  l: "DarkKhaki",
  m: "steelblue",
  r: "DarkSeaGreen",
  p: "yellow",
  q: "lightgreen"
}, _defineProperty(_amino_acid_colors, "r", "orange"), _defineProperty(_amino_acid_colors, "s", "green"), _defineProperty(_amino_acid_colors, "t", "DeepSkyBlue"), _defineProperty(_amino_acid_colors, "v", "Gold"), _defineProperty(_amino_acid_colors, "w", "HotPink"), _defineProperty(_amino_acid_colors, "x", "black"), _defineProperty(_amino_acid_colors, "y", "IndianRed"), _defineProperty(_amino_acid_colors, "A", "lightblue"), _defineProperty(_amino_acid_colors, "C", "pink"), _defineProperty(_amino_acid_colors, "D", "LightSteelBlue"), _defineProperty(_amino_acid_colors, "E", "purple"), _defineProperty(_amino_acid_colors, "F", "AntiqueWhite"), _defineProperty(_amino_acid_colors, "G", "LightSalmon"), _defineProperty(_amino_acid_colors, "H", "CadetBlue"), _defineProperty(_amino_acid_colors, "I", "Crimson"), _defineProperty(_amino_acid_colors, "K", "DarkCyan"), _defineProperty(_amino_acid_colors, "L", "DarkKhaki"), _defineProperty(_amino_acid_colors, "M", "steelblue"), _defineProperty(_amino_acid_colors, "N", "DarkSeaGreen"), _defineProperty(_amino_acid_colors, "P", "yellow"), _defineProperty(_amino_acid_colors, "Q", "lightgreen"), _defineProperty(_amino_acid_colors, "R", "orange"), _defineProperty(_amino_acid_colors, "S", "green"), _defineProperty(_amino_acid_colors, "T", "DeepSkyBlue"), _defineProperty(_amino_acid_colors, "V", "Gold"), _defineProperty(_amino_acid_colors, "W", "HotPink"), _defineProperty(_amino_acid_colors, "X", "black"), _defineProperty(_amino_acid_colors, "Y", "IndianRed"), _amino_acid_colors),
    nucleotide_color = function nucleotide_color(character, position, header) {
  return nucleotide_colors[character];
},
    nucleotide_text_color = function nucleotide_text_color(character, position, header) {
  return nucleotide_text_colors[character];
},
    amino_acid_color = function amino_acid_color(character, position, header) {
  return amino_acid_colors[character];
},
    amino_acid_text_color = function amino_acid_text_color(character, position, header) {
  return character.toUpperCase() != "X" ? "black" : "white";
},
    nucleotide_difference = function nucleotide_difference(desired_record) {
  var desired_header = desired_record.header,
      desired_sequence = desired_record.seq;
  return function (mol, site, header) {
    var desired_color = nucleotide_colors[mol];
    if (mol == "-") return nucleotide_colors["-"];
    if (header == desired_header) return desired_color;
    return mol == desired_sequence[site - 1] ? "white" : desired_color;
  };
};

exports.nucleotide_difference = nucleotide_difference;
exports.amino_acid_text_color = amino_acid_text_color;
exports.amino_acid_color = amino_acid_color;
exports.nucleotide_text_color = nucleotide_text_color;
exports.nucleotide_color = nucleotide_color;
exports.amino_acid_colors = amino_acid_colors;
exports.nucleotide_colors = nucleotide_colors;